import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  public get(name: string): string {
    return localStorage.getItem(name)
  }

  public set(name: string, value: string): void {
    localStorage.setItem(name, value)
  }

  public delete(name: string): void {
    localStorage.removeItem(name)
  }

  public clear(): void {
    localStorage.clear()
  }
}
